<div class="chat-wrapper" [class.chat-open]="selectedContact">
  <!-- Left side Chat Panel -->
  <div class="sidebar">
    <div class="sidebar-header">
      <img (click)="gooApp()" src="assets/images/leftArrow.png" />
      <h3 class="lsc" style="margin-bottom: 0rem !important;">List Of Connections ({{filteredConnectionUser.length || '0'}})</h3>
    </div>

    <!-- Category Tabs -->
    <div class="tabs">
      <button *ngFor="let card of documentCategories" 
              class="tab" 
              [ngClass]="{ active: card.isActive }"
              (click)="onCategoryClick(card)">
        {{ card.title }}
      </button>
    </div>

    <!-- Search -->
    <div class="search-box">
      <i class="bi bi-search"></i>
      <input type="text" 
             placeholder="Search for People" 
             (keydown)="preventLeadingSpace($event)" 
             [(ngModel)]="searchText" />
    </div>

    <!-- Contact List -->
    <div class="contact-list-wrapper">
      <div *ngFor="let rel of filteredUsers">

        <!-- Solo Lawyers -->
        <!-- Solo Lawyers (shown in Solo tab and All tab when type=solo) -->
        <div *ngIf="selectedCategoryTitle === 'solo' || (selectedCategoryTitle === 'all' && rel.type === 'solo')"
             class="contact"
             [class.active]="selectedContact === rel"
             (click)="onSelectContact(rel)">
          <div class="avatar">
            <img *ngIf="rel.profile_pic" [src]="rel.profile_pic" alt="User" />
            <div *ngIf="!rel.profile_pic" class="avatar-text">
              {{ rel.name.charAt(0) }}
            </div>
            <span *ngIf="rel.isOnline" class="online"></span>
          </div>
          <div class="contact-info">
            <div style="display:flex; justify-content:space-between; align-items:center;">
              <p class="name">{{ rel.name }}</p>
              <span *ngIf="rel.lastMessageTimeDisplay" class="time">{{ rel.lastMessageTimeDisplay }}</span>
            </div>
            <div style="display:flex; justify-content:space-between; align-items:center;">
              <p *ngIf="rel.lastMessage && rel.isSubActive !== false" class="msg-preview">{{ rel.lastMessage }}</p>
              <span *ngIf="rel.unreadCount" class="badge">{{ rel.unreadCount }}</span>
            </div>
          </div>
        </div>

        <!-- Firm Lawyers — flat list: username - firm_name (shown in Firm tab and All tab when type=entity) -->
        <div *ngIf="selectedCategoryTitle === 'firm' || (selectedCategoryTitle === 'all' && rel.type === 'entity')"
             class="contact"
             [class.active]="selectedContact === rel"
             (click)="onSelectContact(rel)">
          <div class="avatar">
            <img *ngIf="rel.profile_pic" [src]="rel.profile_pic" alt="User" />
            <div *ngIf="!rel.profile_pic" class="avatar-text">
              {{ rel.name.charAt(0) }}
            </div>
            <span *ngIf="rel.isOnline" class="online"></span>
          </div>
          <div class="contact-info">
            <div style="display:flex; justify-content:space-between; align-items:center;">
              <p class="name">{{ rel.name }} - {{ rel.firm_name }}</p>
              <span *ngIf="rel.lastMessageTimeDisplay" class="time">{{ rel.lastMessageTimeDisplay }}</span>
            </div>
            <div style="display:flex; justify-content:space-between; align-items:center;">
              <p *ngIf="rel.lastMessage" class="msg-preview">{{ rel.lastMessage }}</p>
              <span *ngIf="rel.unreadCount" class="badge">{{ rel.unreadCount }}</span>
            </div>
          </div>
        </div>

      </div>

      <!-- Empty State -->
      <div *ngIf="filteredConnectionUser.length === 0" class="no-connection-msg">
        No {{ selectedCategoryTitle === 'solo' ? 'solo practitioners' : 'firms' }} available
      </div>
    </div>
  </div>

  <!-- Right side Chat Panel -->
  <div class="chat-panel" *ngIf="selectedContact">
    <div class="chat-header">
      <div class="user">
        <button class="mobile-back-btn" type="button" (click)="backToList()" aria-label="Back to chats">
          <i class="bi bi-arrow-left"></i>
        </button>
        <div class="chat-avatar-wrapper">
          <img *ngIf="selectedContact.profile_pic" [src]="selectedContact.profile_pic" alt="User" />
          <div *ngIf="!selectedContact.profile_pic" class="avatar-text">
            {{ getSelectedChatDisplayName().charAt(0) || '?' }}
          </div>
          <span *ngIf="selectedContact.isOnline" class="online-dot"></span>
        </div>
        <div class="userstatus">
          <h4 class="username">{{ selectedContact.type === 'entity' && selectedContact.firm_name ? (selectedContact.name + ' - ' + selectedContact.firm_name) : getSelectedChatDisplayName() }}</h4>
          <p *ngIf="getPresenceLabel(selectedContact)" class="status">{{ getPresenceLabel(selectedContact) }}</p>
        </div>
      </div>
      <div class="icons">
        <div class="chat-search-wrap">
          <i class="bi bi-search chat-search-icon"></i>
          <input class="chat-search-input" type="search" placeholder="Search messages…"
                 autocomplete="off" (input)="restricttextSpace($event)" [(ngModel)]="clientSearch" />
        </div>
      </div>
    </div>

    <div class="chat-body lawyer-inactive-body" *ngIf="isLawyerInactive">
      <p class="lawyer-inactive-text">Chat window with Lawyer {{ selectedContact?.name }} is no longer available. Please try after some time.</p>
    </div>

    <div class="chat-body" #chatBody *ngIf="!isLawyerInactive">
      <div *ngIf="isLoadingMore && messages.length > 0" class="pagination-loader">
        <div class="chat-spinner"></div>
      </div>
      <ng-container *ngFor="let item of (filteredMessages | groupMessagesByDate)">
        <div *ngIf="item.isDateDivider; else msgTpl" class="date-divider"><span>{{ item.label }}</span></div>
        <ng-template #msgTpl>
          <div [ngClass]="{'message-container': true, 'right2': item.action === 'SENT', 'left2': item.action !== 'SENT'}">
            <div class="message2">
              <p [innerHTML]="item.text"></p>
            </div>
            <span class="time2">{{ item.timestamp | date:'shortTime' }}</span>
          </div>
        </ng-template>
      </ng-container>

      <!-- WhatsApp-style typing bubble -->
      <div *ngIf="isContactTyping" class="typing-bubble-wrapper">
        <div class="typing-bubble">
          <span class="typing-dot"></span>
          <span class="typing-dot"></span>
          <span class="typing-dot"></span>
        </div>
      </div>
    </div>

    <!-- Chat Input -->
    <div class="chat-input" *ngIf="!isConsultationEnded && !isLawyerInactive">
      <textarea class="chat-textarea" id="title" name="caseno" #messege_input #messageTextarea
                (keydown)="onKeyDown($event)" (input)="onInputChange()" [(ngModel)]="messegeInput"
                rows="1"
                required placeholder="Type your message..."></textarea>
      <button class="send-btn"
              [disabled]="messegeInput.length === 0 || isMessageEmpty()"
              (click)="sendMessage(messege_input.value)">
        <i class="fa fa-paper-plane"></i>
      </button>
    </div>

    <!-- Consultation Ended Box -->
    <div class="ended-box" *ngIf="isConsultationEnded">
      <ng-container *ngIf="isUpcomingAppointment">
        <p class="ended-title">Chat will be available 1 hour before your scheduled appointment</p>
        <div class="chatSes">
          <div class="chat-ended-text">
            Appointment: {{ selectedContact.appointment_from | date: 'MMM dd, yyyy • h:mm a' }}
          </div>
          <button class="reopen-btn" (click)="navigateToappointments()">
            View Appointment Details
          </button>
        </div>
      </ng-container>
      <ng-container *ngIf="!isUpcomingAppointment">
        <p class="ended-title">Conversation has ended. Click below to reopen</p>
        <div class="chatSes">
          <div class="chat-ended-text">Chat session has ended</div>
          <button class="reopen-btn" (click)="reopenChat()">Reopen Chat</button>
        </div>
      </ng-container>
    </div>
  </div>

  <!-- Empty State - No Contact Selected -->
  <div class="chat-panel" *ngIf="!selectedContact && (filteredConnectionUser.length || 0) > 0">
    <div class="empty-state2">
      <img src="assets/images/nomessage.svg" alt="No messages" class="empty-image" />
      <h3>Start a Conversation</h3>
      <p style="margin-top: 2px;">By Selecting a Contact or Connection</p>
    </div>
    <div class="encryption-info">
      <mat-icon>lock</mat-icon>
      <span>Your personal messages are end-to-end encrypted</span>
    </div>
  </div>

  <!-- Empty State - No Connections -->
  <div class="chat-panel" *ngIf="filteredConnectionUser.length === 0">
    <div class="empty-state2">
      <img src="assets/images/nomessage.svg" alt="No messages" class="empty-image" />
      <h3>No Messages Yet...</h3>
      <p style="margin-top: 2px;">Start chatting with your contacts and enhance your communication now.</p>
      <button class="start-chat-btn" routerLink="/connections">Start Chat</button>
    </div>
  </div>
</div>